import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { FaqI } from 'src/app/interfaces/faq.interface';
import { BackendResponse } from 'src/app/interfaces/response.interface';
import { handleError } from 'src/app/tools/tools';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class FaqService {
  constructor(private readonly http: HttpClient) {}
  private readonly url = environment.url + 'faq/';

  getAllFilter(params?: HttpParams) {
    return this.http.get<BackendResponse>(this.url, { params }).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as { entities: FaqI[]; count: number })
    );
  }

  insert(data: FaqI) {
    return this.http.post<BackendResponse>(this.url, data).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as FaqI)
    );
  }

  update(data: FaqI) {
    const direction = this.url + data.id;
    return this.http.put<BackendResponse>(direction, data).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as FaqI)
    );
  }
}
